/* eslint ember/no-new-mixins:"off" */
// This mixin provides 'elementWidth' and 'elementHeight' properties that update
// automatically. Extend your view/component with this mixin to watch for size
// changes on your parent element.
//
// The resize response is scheduled afterRender. You can observe 'elementWidth'
// and 'elementHeight' to be notified when the responsive breakpoint has changed.
//
// Because we're measuring the element for you here, the behavior is dependent
// on the browser playing nicely, but we also need to Ember.run for you so that
// the size is measured correctly. There may be a better way to do this?
//

import { join, scheduleOnce } from '@ember/runloop';
import Mixin from '@ember/object/mixin';
export default Mixin.create({
  elementWidth: null,
  elementHeight: null,
  boundResizeHandler: null,
  didInsertElement(...args) {
    this._super(...args);
    this.set('boundResizeHandler', this.resizeHandler.bind(this));
    window.addEventListener('resize', this.boundResizeHandler);
    this.resized();
  },
  willDestroyElement(...args) {
    this._super(...args);
    window.removeEventListener('resize', this.boundResizeHandler);
  },
  resizeHandler() {
    join(() => {
      scheduleOnce('afterRender', this, this.resized);
    });
  },
  resized() {
    if (this.element) {
      const style = getComputedStyle(this.element, null);
      this.set('elementWidth', Number.parseFloat(style.width.replace('px', '')));
      this.set('elementHeight', Number.parseFloat(style.height.replace('px', '')));
    }
  }
});